import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed497e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import { isEmpty } from 'lodash'
import {
  queryLocusAoiAll,
  alarmStrategyUpdate,
  alarmStrategyAdd,
  alarmStrategyDetail,
} from '@/api'
import { CODE_ENUM, ALARM_LEVEL_TYPE, WARNING_TYPE_ENUM } from '@/common'
import { ElMessage, genFileId } from 'element-plus'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'form-drawer-1',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t




// 等级告警
const levelOps = [
  {
    label: t('W_TACTICS.main'),
    value: ALARM_LEVEL_TYPE.ALARM_MAIN,
  },
  {
    label: t('W_TACTICS.minor'),
    value: ALARM_LEVEL_TYPE.ALARM_MINOR,
  },
  {
    label: t('W_TACTICS.urgency'),
    value: ALARM_LEVEL_TYPE.ALARM_URGENCY,
  },
  {
    label: t('W_TACTICS.warn'),
    value: ALARM_LEVEL_TYPE.ALARM_WARN,
  },
  // {
  //   label: t('W_TACTICS.clean'),
  //   value: ALARM_LEVEL_TYPE.ALARM_CLEAN,
  // },
]

const formRef = ref()

const form: any = ref({
  name: '',
  alarmLevelCode: undefined,
  aoiIds: [],
})

const rules: any = {
  name: [{ required: true, message: '请输入' }],
  aoiIds: [{ required: true, message: '请选择', type: 'array' }],
  alarmLevelCode: [{ required: true, message: '请选择' }],
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryAoiList()
      queryDetial()
    }
  },
  {
    deep: true,
  }
)

const aoiList: any = ref([])
const queryAoiList = async () => {
  const res: any = await queryLocusAoiAll()
  aoiList.value = (res?.data || []).map(({ aoiName, id }: any) => {
    return {
      label: aoiName,
      value: id,
    }
  })
}

const queryDetial = async () => {
  if (!props.data.id) {
    return
  }
  const res: any = await alarmStrategyDetail({
    alarmStrategyId: props.data?.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const mo = res?.data || {}
    const { aoiInfos, name, alarmLevelCode } = mo
    const aoiIds = (aoiInfos || []).map((item: any) => item.aoiId)
    form.value = {
      aoiIds,
      name,
      alarmLevelCode,
    }
  }
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const loading = ref(false)
const handleAPI = async () => {
  loading.value = true
  const fn = props.data.id ? alarmStrategyUpdate : alarmStrategyAdd
  const res: any = await fn({
    ...form.value,
    triggerId: props.data?.id,
    triggerTypeCode: WARNING_TYPE_ENUM.AOI,
  }).finally(() => {
    loading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    $emit('on-success')
    handleClose()
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: props.data.id ? '编辑告警策略' : '新建告警策略',
    size: "480px",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: submit,
          loading: loading.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          onClick: handleClose,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        rules: rules,
        class: "form ws_common_form",
        "label-width": 80
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_TACTICS.labelNameForm'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                modelModifiers: { trim: true },
                maxlength: "50",
                placeholder: _ctx.$t('W_TACTICS.labelNamePla'),
                style: {"width":"355px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_TACTICS.labelAoiForm'),
            prop: "aoiIds"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.value.aoiIds,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.aoiIds) = $event)),
                class: "ws_select_form",
                multiple: "",
                style: {"width":"355px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aoiList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_TACTICS.alarmLevel'),
            prop: "alarmLevelCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.value.alarmLevelCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.alarmLevelCode) = $event)),
                class: "ws_select",
                clearable: "",
                style: {"width":"355px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(levelOps, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})